module.exports = __webpack_public_path__ + "img/nx7.png";